"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSchedulerId = exports.filterSubscription = exports.filterNonSubscription = exports.SUBSCRIPTION_KEY = exports.STATUS = exports.SEQUENCE_WELCOME = exports.SEQUENCE_FREE = exports.SEQUENCE_BULLETIN = exports.FREQUENCY = exports.CSubscription = void 0;
var _entry = require("./entry");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const SUBSCRIPTION_KEY = exports.SUBSCRIPTION_KEY = "subscription";

/** the weekly bulletin */
const SEQUENCE_BULLETIN = exports.SEQUENCE_BULLETIN = "bulletin";

/** the daily welcome sequence */
const SEQUENCE_WELCOME = exports.SEQUENCE_WELCOME = "welcome";
const SEQUENCE_FREE = exports.SEQUENCE_FREE = "freecourse";
let FREQUENCY = exports.FREQUENCY = /*#__PURE__*/function (FREQUENCY) {
  FREQUENCY["DAILY"] = "daily";
  FREQUENCY["WEEKLY"] = "weekly";
  return FREQUENCY;
}({});
;
let STATUS = exports.STATUS = /*#__PURE__*/function (STATUS) {
  STATUS["ACTIVE"] = "active";
  STATUS["CANCELLED"] = "cancelled";
  STATUS["COMPLETED"] = "completed";
  STATUS["INVALID"] = "invalid";
  return STATUS;
}({});
/**
 * Get the scheduler id for the current date and time that is used to send the email
 * of the specified frequency
 */
const getSchedulerId = (date, frequency, usePrevious = false) => {
  /*const dayOfWeek = frequency == FREQUENCY.WEEKLY ? date.getDay() : FREQUENCY.DAILY;
  const hour = date.getHours();
  let partOfDay = 0;
   if (hour >= 0 && hour < 4) {
      partOfDay = 1;
  } else if (hour >= 4 && hour < 8) {
      partOfDay = 2;
  } else if (hour >= 8 && hour < 12) {
      partOfDay = 3;
  } else if (hour >= 12 && hour < 16) {
      partOfDay = 4;
  } else if (hour >= 16 && hour < 20) {
      partOfDay = 5;
  } else if (hour >= 20 && hour < 24) {
      partOfDay = 6;
  }
   if (usePrevious) {
      partOfDay = partOfDay - 1;
      if (partOfDay == 0) {
          partOfDay = 6;
      }
  }
   const schedulerId = `sdl-${dayOfWeek}-${partOfDay}`;
   return schedulerId;*/

  return FREQUENCY.DAILY;
};

/**
 * The subscription triggers the sending of the email
 */
exports.getSchedulerId = getSchedulerId;
class CSubscription extends _entry.CEntry {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "entryId", SUBSCRIPTION_KEY);
    _defineProperty(this, "primaryKey", ["email", "sequenceId"]);
    // we must find the subscription by the email
    _defineProperty(this, "rangeKey", "schedulerId");
    // each schdeuler has a unique id to find the subscriptions to send
    _defineProperty(this, "email", null);
    _defineProperty(this, "schedulerId", null);
    _defineProperty(this, "status", null);
    // specify the sequence of emails to send
    _defineProperty(this, "sequenceId", null);
    // specify last performed step
    _defineProperty(this, "performedStep", null);
    // specify the frequency of sending the emails
    _defineProperty(this, "frequency", null);
    // a value that uniquely identifies the subscription item - used for unsubscribing
    _defineProperty(this, "subscriptionHash", null);
    // how did a user subscribe? and what is the reference identifier?
    _defineProperty(this, "referenceId", null);
    _defineProperty(this, "referenceType", null);
  }
}
exports.CSubscription = CSubscription;
;
;

/**
 * The type of an array of the properties
 */

/**
 * An array of the properties
 */
const propsArray = Object.keys(new CSubscription());

/**
 * Get the properties from a bigger object
 */
const filterSubscription = (props, {
  fallback = {},
  override = {}
} = {}) => {
  const data = Object.assign(propsArray.reduce((r, k) => {
    // do not overwrite the IEntry values with undefined
    return _objectSpread(_objectSpread({}, r), {}, {
      [k]: function (_props$k, _props$k$localeCompar) {
        if (props[k] !== undefined && ((_props$k = props[k]) === null || _props$k === void 0 || (_props$k$localeCompar = _props$k.localeCompare) === null || _props$k$localeCompar === void 0 ? void 0 : _props$k$localeCompar.call(_props$k, '')) !== 0) {
          return props[k];
        }
        if (fallback[k] !== undefined) {
          return fallback[k];
        }
        if (r[k] !== null) {
          return r[k];
        }
        return undefined;
      }()
    });
  }, new CSubscription()), override);
  return data;
};
exports.filterSubscription = filterSubscription;
const filterNonSubscription = props => Object.keys(props).reduce((r, k) => {
  return Object.assign(r, !propsArray.includes(k) ? {
    [k]: props[k]
  } : {});
}, {});
exports.filterNonSubscription = filterNonSubscription;